module.exports = __webpack_public_path__ + "components/MapControl/svg/Interesująca osobliwość przyrodnicza.svg?c067c0f7";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Interesująca osobliwość przyrodnicza.svg
// module id = 1940
// module chunks = 0